import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../hooks/hooks";
import PageLoader from "../../../../../components/PageLoader";
import Table from "../../../../../common/components/table-manager/v1.1/table";
import TransactionLogsFilterComponent from "../components/transaction-logs-filter.component";
import { toast } from "react-toastify";
import * as R from 'ramda';
import axios from "axios";
import { filter } from "lodash";
import { TransactionLogDetails } from "../components/transaction-details";
import { TransactionFlowView } from "../components/transaction-flow-view";

const TransactionLogs = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(25);

  const [
    filterData,
    setFilterData
  ] = useState<any>({
    transaction_id: "",
    message_id: "",
    bpp_id: "",
    bap_id: "",
    action: "search",
    domain: "",
    city: '',
    transaction_from: '',
    transaction_to: '',
  })

  // const [filters, setFilters] = useState<any>({
  //   transaction_id: "",
  //   message_id: "",
  //   bpp_id: "bpp.dbs.digiit.ai",
  //   bap_id: "",
  //   action: "search",
  //   domain: "ONDC:RET10",
  //   city: 'std:080',
  //   transaction_from: Date.UTC,
  //   transaction_to: Date.UTC,
  // });

  // const [page, setPage] = useState(1);
  const [selected, setSelected] = useState<any>(null);
  const [flowData, setFlowData] = useState<any>(null);
  const [data, setData] = useState({
    items: [], Pagination: {
      PageIndex: 1,
      PageNumber: 1,
      PageSize: 10,
      TotalCount: 1,
      TotalPages: 1,
      HasPreviousPage: false,
      HasNextPage: false,
    }
  });

  const fetchLogs = async (filters: any) => {
    setIsLoading(true)
    const params = {
      action: filters.action,
      // tenant: filters.tenant,
      transaction_id: filters.transaction_id,
      message_id: filters.message_id,
      bap_id: filters.bap_id,
      bpp_id: filters.bpp_id,
      domain: filters.domain,
      cities: filters.city,
      startDate: filters.startDate,
      endDate: filters.endDate,
      pageData,
      limit: pageSize
    };

    // const res = await axios.get("http://localhost:3004/logs/transactions", { params });
    const res = await axios.get(`${process.env.REACT_APP_BPP_URL}/logs/transactions`, { params });
    console.log('res.data', res.data)
    const transformedData = transformLogs(res.data?.items);
    console.log('transformedData', transformedData)
    setData({ items: transformedData, Pagination: res.data?.Pagination });
    setIsLoading(false)
  };

  const transformLogs = (data: any) => {

    return data?.map((item: any) => ({
      id: item._id,
      timestamp: item.timestamp,
      bap_id: item.logData?.context?.bap_id || "-",
      bpp_id: item.logData?.context?.bpp_id || item.tenant_id || "-",
      action: item.action,
      domain: item.logData?.context?.domain || "-",
      city: item.logData?.context?.city || "-",
      requestType: item.requestType,
      transaction_id: item.transaction_id || item.logData?.context?.transaction_id || "-",
      message_id: item.message_id || item.logData?.context?.message_id || "-"
    }))

  }

  // useEffect(() => { fetchLogs(); }, [filters, pageSize]);

  const fetchFlow = async (transaction_id: string) => {

    // const res = await axios.get("http://localhost:3004/logs/transactions/flow", {
    //   params: { transaction_id }
    // });
    const res = await axios.get(`${process.env.REACT_APP_BPP_URL}/logs/transactions/flow`, {
      params: { transaction_id }
    });
    setFlowData(res.data);
  };

  const [columnDefs, setColumnDefs] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'transaction_id', headerName: 'Transaction ID', searchField: 'transaction_id', filter: true, filterType: 'text' },
      { field: 'message_id', headerName: 'Message ID', filter: true, filterType: 'text' },
      { field: 'bap_id', headerName: 'Buyer App', filter: true, filterType: 'text' },
      { field: 'bpp_id', headerName: 'Seller App', filter: true, filterType: 'text' },
      { field: 'action', headerName: 'Action', searchField: 'action', filter: true, filterType: 'text' },
      { field: 'domain', headerName: 'Domain', searchField: 'domain', filter: true, filterType: 'text' },
      { field: 'city', headerName: 'City', searchField: 'city', filter: true, filterType: 'text' },
      { field: 'type', headerName: 'Type', searchField: 'type', filter: true, filterType: 'text' },
      { field: 'timestamp', headerName: 'Timestamp', searchField: 'timestamp', filter: true, filterType: 'text' },
    ]);
  }

  const getTypeName = (data: any) => {
    if (Array.isArray(data)) {
      return data.join('\n');
    }
    return data;
  };


  useEffect(() => {
    console.log('pageSize, pageData', pageSize, pageData)
    createColumnDefs();
    fetchLogs(filterData);
  }, [pageSize, pageData])


  const handleEdit = (data: any) => {
    // navigate(`${data?.GatewayId}/${data?.TenantId}`)
  }

  const handleView = (data: any) => {
    setSelected(data)
  }

  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      // name: 'Reload',
      callback: () => handleReloadData(),
    }
  ];

  const handleInnerFormChange: any = (event: any, field: string) => {
    console.log('event', event, 'field', field)
    setFilterData({ ...filterData, [field]: event });
  }

  const handleFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setFilterData({ ...filterData, [fields[0]]: value });
  }


  const handleReloadData = () => {
    fetchLogs(filterData);
  }

  const handleSearch = (data: any) => {
    console.log('Search data', data)
    // if (!data?.type || !data?.domain || !data?.country) {
    //   toast('Type, Domain and Country are mandatory');
    //   return;
    // }
    setFilterData({ ...data })

    fetchLogs({ ...data });

  }

  return (
    <>

      {isLoading ? <PageLoader /> :
        <>

          <div className='flex w-full justify-start items-end p-4'>
            <TransactionLogsFilterComponent
              apply={handleSearch}
              handleInnerFormChange={handleInnerFormChange}
              handleFormChange={handleFormChange}
              selectedGateway={filterData}
            />
          </div>
          <Table columnData={columnDefs}
            rowData={data.items || []}
            setPageData={setPageData}
            setPageSize={setPageSize}
            enableFilter={false}
            onSearch={handleSearch}
            paginationData={data?.Pagination}
            onEdit={handleEdit}
            onViewList={handleView}
            additionButtons={additionButtons}
            // handleSubscribeTrigger={handleSubscribeTrigger}
            // isEnableSubscribeTrigger={true}
            headingName="Transaction Logs"
            checkboxConfig={{
              allowMultiSelect: true,
              defaultSelectedIds: [],
              isDisabled: false,
              keyColumn: 'id',
            }}
          />

          {selected && !flowData && (
            <TransactionLogDetails
              log={selected}
              onBack={() => setSelected(null)}
              onViewFlow={() =>
                fetchFlow(
                  selected.transaction_id ||
                  selected.logData?.context?.transaction_id
                )
              }
            />
          )}

          {flowData && (
            <TransactionFlowView
              logs={flowData}
              onBack={() => setFlowData(null)}
            />
          )}
        </>
      }
    </>
  );
};

export default TransactionLogs;


